export default [
    {
        comment: 'use . instead of : at the end of the sentence',
        error_id: 'T-DSRC-01',
        data: [
            {
                cross_section: '4420',
                base: {
                    'channel': 200,
                    'lob': 200,
                    'rob': 200
                },
                compare: {
                    'channel': 200,
                    'lob': 180,
                    'rob': 220
                }
            },
            {
                cross_section: '5505',
                base: {
                    'channel': 260,
                    'lob': 285,
                    'rob': 250
                },
                compare: {
                    'channel': 260,
                    'lob': 285,
                    'rob': 220
                }
            },
        ]
    }
]